import { isEmpty } from "./isEmpty"

type ConvertToLocaleParams = {
  amount: number
  currency_code: string
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  locale?: string
}

/**
 * 實務上不寫小數的幣別。
 *
 * `Intl` 是照 ISO 4217 的「最小單位」判斷的,TWD 在那張表上是 2 位 ——
 * 所以預設印出「NT$1,348.00」。但台灣的標價不寫角分,顯示成那樣會讓人以為
 * 系統算錯了。JPY 之類 `Intl` 本來就當 0 位的列不列都一樣,列著當文件。
 *
 * ⚠️ 這只影響**顯示**。金額本身照原樣存放與計算,這裡不改資料。
 */
const ZERO_DECIMAL_DISPLAY = ["twd", "jpy", "krw", "vnd"]

export const convertToLocale = ({
  amount,
  currency_code,
  minimumFractionDigits,
  maximumFractionDigits,
  locale = "en-US",
}: ConvertToLocaleParams) => {
  if (!currency_code || isEmpty(currency_code)) {
    return amount.toString()
  }

  // 呼叫端有指定就聽它的,沒指定才套幣別的預設
  const zeroDecimal = ZERO_DECIMAL_DISPLAY.includes(currency_code.toLowerCase())

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency_code,
    minimumFractionDigits:
      minimumFractionDigits ?? (zeroDecimal ? 0 : undefined),
    maximumFractionDigits:
      maximumFractionDigits ?? (zeroDecimal ? 0 : undefined),
  }).format(amount)
}
